$(document).ready(function () {
  // pagination arrow and wrap div
  setTimeout(function () {
    if ($(window).width() < 801) {
      $('.swiper-button-prev').prependTo('.pagi-main');
      $('.swiper-button-next').appendTo('.pagi-main');
    }
    else {
      $('.swiper-button-prev').prependTo('.next-previous');
      $('.swiper-button-next').appendTo('.next-previous');
    }
  }, 1000);
  // footer logo
  $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
  $(".footerItems1 a").removeClass("button");
  $(".generalmessage").prependTo(".header");
  //prepend general message into header
  if ($("body").hasClass("generalMessageOn")) {
    $(".generalmessage").prependTo(".header");
  }
  const fes = $('.card-outer .emailSignup');
  fes.find('.emailSubmitButton').text('sign up');
  fes.find('.inputFieldTextbox').val('');
  fes.find('.inputFieldTextbox').attr('placeholder', 'Email Address:');

});


$(window).load(function () {

  $('body').addClass('pageIsLoaded');
  $(".footerItems1 a").removeClass("button");
  // Weather Bug
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (!weatherBugSet && str != '') {
      $('#weatherBugWidget').addClass('weatherBugSet');
      var findSpace = str.lastIndexOf(' ');
      var stringLength = str.length;
      var res = str.substring(findSpace, stringLength);
      var start = str.substring(0, findSpace);
      $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
      $('#weatherBugWidget').css('visibility', 'visible');
    }
  }, 12);
  if ($(window).width() < 801) {
    $('.ticket').insertAfter('.header-inner');
    $('.homepage .siteInfoBanner').insertAfter('#swiperWidget');
  }
  else {
    $('.ticket').appendTo('.right-top-header');
    $('.homepage .siteInfoBanner').insertAfter('.header-container');
  }

  // pagination arrow and wrap div
  setTimeout(function () {
    if ($(window).width() < 801) {
      $('.swiper-button-prev').prependTo('.pagi-main');
      $('.swiper-button-next').appendTo('.pagi-main');
    }
    else {
      $('.swiper-button-prev').prependTo('.next-previous');
      $('.swiper-button-next').appendTo('.next-previous');
    }
  }, 1000);


  $('.swiper-pagination').each(function (i, item) {
    $(this).wrap("<div class='pagi-main'></div>");
  });
});

$(window).resize(function () {
  if ($(window).width() < 801) {
    $('.ticket').insertAfter('.header-inner');
    $('.homepage .siteInfoBanner').insertAfter('#swiperWidget');
  }
  else {
    $('.ticket').appendTo('.right-top-header');
    $('.homepage .siteInfoBanner').insertAfter('.header-container');
  }

  // pagination arrow and wrap div

  if ($(window).width() < 801) {
    $('.swiper-button-prev').prependTo('.pagi-main');
    $('.swiper-button-next').appendTo('.pagi-main');
  }
  else {
    $('.swiper-button-prev').prependTo('.next-previous');
    $('.swiper-button-next').appendTo('.next-previous');
  }
  $(".footerItems1 a").removeClass("button");
});